import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { Page } from '../model/Page';
import { Observable } from 'rxjs';
import { DashboardFirstPartDTO } from '../model/DashboardFirstPartDTO';
import { KeyDriverScoreDTO } from '../model/KeyDriverScoreDTO';
import { HeatmapDTO } from '../model/HeatmapDTO';
import { DepartmentDTO } from '../model/DepartamentDTO';
import { KeyDriversDTO } from '../model/KeyDriversDTO';
import { HeatmapValueDTO } from '../model/HeatmapValueDTO';
import { UniverseDTO } from '../model/UniverseDTO';
import { ParticipationEvolutionDTO } from '../model/ParticipationEvolutionDTO';
import { KeyDriverEvolutionDTO } from '../model/KeyDriverEvolutionDTO';
import { MyMissionsDTO } from '../model/MyMissionsDTO';
import { MissionDTO } from '../model/MissionDTO';
import { ActionDTO } from '../model/ActionDTO';
import { CommentDTO } from '../model/CommentDTO';
import { HomeDTO } from '../model/HomeDTO';
import { ResourcesDTO } from '../model/ResourcesDTO';
import { CommentResumeDTO } from '../model/CommentResumeDTO';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private BASE_URL = '/Dashboard';
  private FIRST_PART = '/firstPart';
  private HEATMAP = '/getHeatmap';
  private UNIVERSE = '/surveyUniverse';
  private PATICIPATION_EVOLUTION = '/surveyParticipationEvolution';
  private KEYDRIVER_EVOLUTION = '/keydriverEvolution';
  private COMMENTS = '/getComments';
  private COMMENT_LIST = '/comment-list';
  private MY_MISSIONS = '/myMissions';
  private HOME = '/home';
  private HAS_DATA = '/hasData';
  private REPLY_COMMENT = '/reply/comment';

  constructor(private http: HttpService) { }

  getFirstPart(isNPS?: boolean, pollId?: string, departmentIds?: string[], dateFrom?: string, dateTo?: string): Observable<DashboardFirstPartDTO> {
    let url = this.BASE_URL + this.FIRST_PART;
    let params = new HttpParams();

    if (isNPS != null) {
      params = params.append("isNPS", isNPS.toString());
    }

    if (dateFrom != null) {
      params = params.append("dateFrom", dateFrom);
    }

    if (dateTo != null) {
      params = params.append("dateTo", dateTo);
    }

    let body = {
      polls: pollId ? [pollId] : [],
      departments: departmentIds ? departmentIds : []
    };

    return this.http.request<DashboardFirstPartDTO>('POST', url, body, params).pipe(
      map(response => {
        var data = new DashboardFirstPartDTO();
        data.fillFromJSON(response);
        let strengths = data.strengths.map(item => {
          let data = new KeyDriverScoreDTO();
          data.fillFromJSON(item);
          return data
        })
        data.strengths = strengths;
        let opportunities = data.opportunities.map(item => {
          let data = new KeyDriverScoreDTO();
          data.fillFromJSON(item);
          return data
        })
        data.opportunities = opportunities;
        let actionOne = new ActionDTO();
        actionOne.fillFromJSON(data.actionOne);
        data.actionOne = actionOne;

        let resource = new ResourcesDTO();
        resource.fillFromJSON(data.resource);
        data.resource = resource;
        return data;
      })
    );
  }

  getHeatmap(isNPS?: boolean, pollId?: string, departmentListIds?: string[], dateFrom?: string, dateTo?: string): Observable<HeatmapDTO> {
    let url = this.BASE_URL + this.HEATMAP;
    let params = new HttpParams();

    if (isNPS != null) {
      params = params.append("isNPS", isNPS.toString());
    }

    if (dateFrom != null) {
      params = params.append("dateFrom", dateFrom);
    }

    if (dateTo != null) {
      params = params.append("dateTo", dateTo);
    }

    let body = {
      polls: pollId ? [pollId] : [],
      departments: departmentListIds ? departmentListIds : []
    }

    return this.http.post<HeatmapDTO>(url, params, body).pipe(
      map(response => {
        var data = new HeatmapDTO();
        data.fillFromJSON(response);
        let departments = data.departments.map(item => {
          let data = new DepartmentDTO();
          data.fillFromJSON(item);
          return data
        })
        data.departments = departments;
        let keydrivers = data.keyDrivers.map(item => {
          let data = new KeyDriversDTO();
          data.fillFromJSON(item);
          return data
        })
        data.keyDrivers = keydrivers;
        let values = data.values.map(item => {
          let data = new HeatmapValueDTO();
          data.fillFromJSON(item);
          return data
        })
        data.values = values;
        return data;
      })
    );
  }

  getUniverse(pollID: string, departmentIds: string[]): Observable<UniverseDTO> {
    let url = this.BASE_URL + this.UNIVERSE;

    let body = {
      polls: [],
      departments: departmentIds ? departmentIds : []
    }

    if (pollID != null) {
      body.polls.push(pollID);
    }

    return this.http.post<UniverseDTO>(url, null, body).pipe(
      map(response => {
        var data = new UniverseDTO();
        data.fillFromJSON(response);
        return data;
      })
    );
  }

  getParticipationEvolution(periodName?: string, pollId?: string): Observable<ParticipationEvolutionDTO[]> {
    let url = this.BASE_URL + this.PATICIPATION_EVOLUTION;
    let params = new HttpParams();

    if (periodName != null) {
      params = params.append("periodName", periodName);
    }

    if (pollId) {
      params = params.append("pollId", pollId);
    }

    return this.http.get<ParticipationEvolutionDTO[]>(url, params).pipe(
      map(response => {
        let result = response.map(item => {
          var data = new ParticipationEvolutionDTO();
          data.fillFromJSON(item);
          return data;
        });
        return result;
      })
    );
  }

  getKeydriverEvolution(isNPS?: boolean, keydriverID?: string, periodName?: string, pollId?: string): Observable<KeyDriverEvolutionDTO[]> {
    let url = this.BASE_URL + this.KEYDRIVER_EVOLUTION;
    let params = new HttpParams();
    if (isNPS != null) {
      params = params.append("isNPS", isNPS.toString());
    }
    if (keydriverID != null) {
      params = params.append("keydriverID", keydriverID);
    }
    if (periodName != null) {
      params = params.append("periodName", periodName);
    }
    if (pollId) {
      params = params.append("pollId", pollId);
    }
    return this.http.get<KeyDriverEvolutionDTO[]>(url, params).pipe(
      map(response => {
        let result = response.map(item => {
          var data = new KeyDriverEvolutionDTO();
          data.fillFromJSON(item);
          return data;
        });
        return result;
      })
    );
  }

  getComments(currentPage: number, pageSize: number, text: string, pollId?: string): Observable<Page<CommentDTO>> {
    let url = this.BASE_URL + this.COMMENTS;
    var httpParams = new HttpParams();

    httpParams = httpParams.append('currentPage', currentPage.toString());

    httpParams = httpParams.append('pageSize', pageSize.toString());

    if (text) {
      httpParams = httpParams.append('searchKey', text);
    }

    if (pollId) {
      httpParams = httpParams.append('pollId', pollId);
    }

    return this.http.get<Page<CommentDTO>>(url, httpParams).pipe(
      map(response => {
        var obj = new Page<CommentDTO>();
        obj.currentPage = response.currentPage;
        obj.length = response.length;
        obj.pageSize = response.pageSize;
        obj.results = response.results.map(item => {
          var data = new CommentDTO();
          data.fillFromJSON(item);
          let key = new KeyDriversDTO();
          key.fillFromJSON(data.keyDriver);
          data.keyDriver = key;

          return data;
        })
        return obj;
      })
    );
  }

  getCommentList(currentPage: number, pageSize: number, text: string, pollId?: string): Observable<CommentResumeDTO[]> {
    let url = this.BASE_URL + this.COMMENT_LIST;
    var httpParams = new HttpParams();

    httpParams = httpParams.append('currentPage', currentPage.toString());

    httpParams = httpParams.append('pageSize', pageSize.toString());

    if (text) {
      httpParams = httpParams.append('searchKey', text);
    }

    if (pollId) {
      httpParams = httpParams.append('pollId', pollId);
    }

    return this.http.get<CommentResumeDTO[]>(url, httpParams).pipe(
      map(response => {
        return response.map(item => {
          var data = new CommentResumeDTO();
          data.fillFromJSON(item);
          return data;
        })
      })
    );
  }

  getMyMissions(): Observable<MyMissionsDTO> {
    let url = this.BASE_URL + this.MY_MISSIONS;
    return this.http.get<MyMissionsDTO>(url).pipe(
      map(response => {
        var data = new MyMissionsDTO();
        data.fillFromJSON(response);
        let missions = data.missions.map(item => {
          let data = new MissionDTO();
          data.fillFromJSON(item);
          return data;
        })
        data.missions = missions;
        return data;
      })
    );
  }

  getHome(): Observable<HomeDTO> {
    let url = this.BASE_URL + this.HOME;
    return this.http.get<HomeDTO>(url).pipe(
      map(response => {
        var data = new HomeDTO();
        data.fillFromJSON(response);
        return data;
      })
    );
  }

  hasDataToShow(): Observable<any> {
    let url = this.BASE_URL + this.HAS_DATA;
    return this.http.get<any>(url).pipe(
      map(response => {
        return response;
      })
    );
  }

  saveComment(id: string, responseComment: string): Observable<any> {
    let url = this.BASE_URL + this.REPLY_COMMENT + '/' + id;
    var httpParams = new HttpParams();
    httpParams = httpParams.append('response', responseComment);
    return this.http.post<any>(url, httpParams, null);
  }

}
